// Hooks
import { useViewport } from "hooks/useViewport";
// Types
import {
  CustomerMenuAddonModifier,
  CustomerMenuProduct,
} from "types/customers";
import { AddonsModifiers } from "pages/Orders/View/OrderCreate/types";
// Components
import { InputQuantity } from "components/Form";
import { CheckBoxLabel } from "../../../CheckBoxLabel";
// Styled
import { StyledCheckbox } from "pages/Orders/View/OrderCreate/styled";
import { FlexContainer } from "styled/Box";

interface AddonsProps {
  selectedProduct: CustomerMenuProduct | null;
  selectedModifiers: AddonsModifiers;
  onCheck: (addonModifier: CustomerMenuAddonModifier, value: boolean) => void;
  setModifierQuantity: (
    addonModifier: CustomerMenuAddonModifier,
    quantity: number,
  ) => void;
}

export const Addons = ({
  selectedProduct,
  selectedModifiers,
  onCheck,
  setModifierQuantity,
}: AddonsProps) => {
  const { isMobile } = useViewport();

  if (!selectedProduct?.addons) {
    return null;
  }

  return (
    <>
      {selectedProduct.addons.map(el => {
        const selected = selectedModifiers.addon.find(a => a.id === el.id);

        const isChecked = !!selected;

        return (
          <>
            <FlexContainer
              key={el.id}
              $fullwidth
              $column={isMobile}
              $gap={10}
              $justify="space-between"
              $align="flex-start"
              $margin="0 0 4px 0"
            >
              <FlexContainer $column $fullwidth>
                <StyledCheckbox
                  label={
                    <CheckBoxLabel
                      label={el.name}
                      fmcPrice={el.fmcCentsPrice}
                      fiatPrice={el.fiatCentsPrice}
                    />
                  }
                  checked={isChecked}
                  onChange={e => onCheck(el, e.target.checked)}
                />

                {!isMobile && isChecked && (
                  <FlexContainer $margin="4px 0 0 26px">
                    <InputQuantity
                      value={selected?.quantity}
                      onChange={(value: number) =>
                        setModifierQuantity(el, value)
                      }
                    />
                  </FlexContainer>
                )}
              </FlexContainer>

              {isMobile && isChecked && (
                <FlexContainer $margin="4px 0 0 26px">
                  <InputQuantity
                    value={selected?.quantity}
                    onChange={(value: number) => setModifierQuantity(el, value)}
                  />
                </FlexContainer>
              )}
            </FlexContainer>
          </>
        );
      })}
    </>
  );
};
